import React from "react";
// Location page

// Default
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

// Mui
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid2";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";

// Custom
import Layout from "../../layout";
import CustomInput from "../../forms/input/Input";
import CustomSearch from "../search/Search";
import CustomOutlinedSelect from "../../forms/select/OutlinedCustomSelect";
import ContainedButton from "../../forms/button/ContainedButton";
import CustomSearchBox from "../search/SearchBox";
import CustomToast from "../../components/toast/CustomToast";

// React icons
import { FaRegTrashAlt } from "react-icons/fa";

// Utils
import { fetchGETRequest, fetchPOSTRequest } from "../../utils/services";
import { ToastState } from "../../types";
import { UnifiedIcon } from "../Icon/UnifiedIcon";

const ConsumerLocation: React.FC = () => {
  const [searchValue, setSearchValue] = useState({
    type: "id",
    value: "",
  });
  const [searchOpen, setSearchOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Address Details");
  const [names, setNames] = useState<string[]>([]);
  const [counter, setCounter] = useState(1);
  const [siteIdInput, setSiteIdInput] = useState<string[]>([]);
  const [toast, setToast] = useState<ToastState>({
    message: "",
    severity: "",
  });
  const [locationData, setLocationData] = useState({
    consumerType: "",
    houseNo: "",
    streetAddress: "",
    city: "",
    state: "",
    zipCode: "",
    latitude: "",
    longitude: "",
  });

  const [linkToCustomer, setLinkToCustomer] = useState("");

  const navigate = useNavigate();

  const TABS = ["Address Details", "Coordinates", "Sites"];

  const consumerTypeOptions = [
    { label: "Personal", value: "Personal" },
    { label: "Business", value: "Business" },
  ];

  // useEffect(() => {
  //   async function getAPIData() {
  //     const response = await fetchGETRequest(`customer/6e701680-a3e2-11ee-9483-cd24c515eaca/assets?assetType=location&pageSize=1&page=1`, {});
  //     console.log(response,"responseresponse");
  //   }
  //   getAPIData()

  // }, [])

  const handleAddRow = () => {
    setSiteIdInput((prevInputs) => [...prevInputs, ""]);
  };

  const handleRemoveRow = (index: number) => {
    setSiteIdInput((prevInputs) => prevInputs.filter((_, i) => i !== index));
  };

  const handleSiteIdInputChange = (value: string, index: number) => {
    setSiteIdInput((prevInputs) => {
      const newInputs = [...prevInputs];
      newInputs[index] = value;
      return newInputs;
    });
  };

  const handleGoToSite = (siteId: string) => {
    setSiteIdInput(siteIdInput);
    navigate("/site", { state: { siteId } });
  };

  const generateUniqueName = () => {
    const newName = `Loc${new Date().getMilliseconds()}`;
    setNames((prevNames) => [...prevNames, newName]);
    setCounter(counter + 1);
    return newName;
  };

  const handleUpdate = async () => {
    if (siteIdInput?.length > 0) {
      try {
        const requestData = {
          tenantId: {
            id: "e936e050-e1d7-11ee-8baa-37d11d926d57",
            entityType: "TENANT",
          },
          name: generateUniqueName(),
          type: "LOCATION",
          label: "NY Building",
          additionalInfo: {
            consumerType: locationData?.consumerType,
            streetAddress: locationData?.streetAddress,
            houseNo: locationData?.houseNo,
            state: locationData?.state,
            city: locationData?.city,
            zip: locationData?.zipCode,
            siteIdInput: siteIdInput,
            latitude: locationData?.latitude,
            longitude: locationData?.longitude,
          },
        };

        //  if (locationData.id && locationData.id.id) {
        //    requestData.id = {
        //      id: locationData.id.id,
        //      entityType: 'ASSET'
        //    };
        //  }

        if (linkToCustomer) {
          let secondResponse = null;
          const response = await fetchPOSTRequest(`asset`, requestData);

          if (response) {
            secondResponse = await fetchPOSTRequest(
              `customer/${linkToCustomer}/asset/${response?.id?.id}`,
              requestData,
              true
            );
          }

          setSearchValue({ ...searchValue, value: response?.id?.id });

          setLocationData({
            consumerType: "",
            houseNo: "",
            streetAddress: "",
            city: "",
            state: "",
            zipCode: "",
            latitude: "",
            longitude: "",
          });

          setSiteIdInput([]);
          setLinkToCustomer("");

          if (secondResponse?.status === 200) {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: response?.id?.id + " " + "Update successful!",
            });
          } else {
            setToast({
              message: response?.message,
              severity: "error",
            });
          }
        } else {
          setToast({
            message: "Link to Customer Field Required",
            severity: "error",
          });
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Error during request",
        });
      }
    } else {
      setToast({
        message: "Please add site",
        severity: "error",
      });
    }
  };

  const handleLocationSearch = async () => {
    try {
      if (!searchValue?.value.trim()) {
        setToast({
          message: "Please enter a valid search value.",
          severity: "error",
        });
        return;
      }

      const response = await fetchGETRequest(
        `asset/${searchValue?.value}`,
        {},
        true
      );

      if (response?.data?.additionalInfo) {
        const {
          consumerType,
          houseNo,
          streetAddress,
          city,
          state,
          zip,
          siteIdInput,
          latitude,
          longitude,
        } = response?.data?.additionalInfo;
        setLocationData({
          // id: response?.data?.id,
          consumerType: consumerType,
          houseNo: houseNo,
          streetAddress: streetAddress,
          city: city,
          state: state,
          zipCode: zip,
          latitude: latitude,
          longitude: longitude,
        });
        setSiteIdInput(siteIdInput);
        setLinkToCustomer(response?.data?.customerId?.id);
      } else {
        setToast({ message: "Location not found", severity: "error" });
      }
      setSearchOpen(false);
    } catch (error: any) {
      console.error("Error fetching consumer:", error.message);
    }
  };

  return (
    <Layout>
      <Card className="customer_title_card">
        <Typography variant="h5">Location Information</Typography>
      </Card>

      <CustomToast
        open={toast?.message}
        severity={toast?.severity}
        setToast={setToast}
      />

      <Card
        className="customer_search_card"
        sx={{
          overflow: "visible",
          position: "relative",
        }}
      >
        <Typography variant="body1" fontWeight={600}>
          Location ID
        </Typography>

        <Stack direction={"row"} gap={"10px"} alignItems={"center"}>
          <CustomSearchBox
            placeholder={"Enter 10 Digit"}
            width={"500px"}
            height={"40px"}
            handleSearchToggle={() => setSearchOpen(!searchOpen)}
            searchOpen={searchOpen}
            dialogBody={
              <Stack direction={"column"} gap={"20px"}>
                <CustomInput
                  label={"Type"}
                  value={searchValue?.type}
                  onChange={(e) =>
                    setSearchValue({
                      ...searchValue,
                      type: e.target.value,
                    })
                  }
                />
                <CustomInput
                  label={"Value"}
                  value={searchValue?.value}
                  onChange={(e) =>
                    setSearchValue({
                      ...searchValue,
                      value: e.target.value,
                    })
                  }
                />
                <ContainedButton
                  label={"Submit"}
                  sx={{
                    width: "100%",
                    fontWeight: 600,
                    color: "#ffffff",
                  }}
                  onClick={handleLocationSearch}
                />
              </Stack>
            }
          />

          <ContainedButton
            label={"Save"}
            sx={{
              width: "fit-content",
              fontWeight: 600,
              height: "35px",
              color: "#ffffff",
            }}
            onClick={handleUpdate}
          />
        </Stack>
      </Card>

      <Card sx={{ mt: "20px" }}>
        <TabContext value={activeTab}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "#CACDD7",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <TabList
              onChange={(_, newValue) => setActiveTab(newValue)}
              scrollButtons={false}
              TabIndicatorProps={{
                style: {
                  backgroundColor: "##1280E7",
                  height: "3px",
                },
              }}
            >
              {TABS.map((item) => {
                return (
                  <Tab
                    label={
                      <Box
                        display="flex"
                        alignItems="center"
                        gap={"7px"}
                        fontWeight={500}
                      >
                        {item}
                      </Box>
                    }
                    value={item}
                    className="consumer_right_card_list_tab"
                  />
                );
              })}
            </TabList>
          </Box>

          <CardContent>
            <TabPanel value={TABS[0]} sx={{ padding: 0 }}>
              <Grid container spacing={2}>
                <Grid size={{ xs: 12, md: 4, lg: 4 }}>
                  <CustomOutlinedSelect
                    label={"Consumer Type"}
                    options={consumerTypeOptions}
                    value={
                      locationData?.consumerType
                        ? {
                            label: locationData?.consumerType,
                            value: locationData?.consumerType,
                          }
                        : null
                    }
                    name={"consumerType"}
                    placeholder={"Select"}
                    onChange={(newValue) =>
                      setLocationData({
                        ...locationData,
                        consumerType: newValue.value as string,
                      })
                    }
                  />
                </Grid>

                <Grid size={{ xs: 12, md: 4, lg: 4 }}>
                  <CustomInput
                    label={"House No."}
                    value={locationData?.houseNo}
                    placeholder={"House No."}
                    name={"houseNo"}
                    onChange={(e) =>
                      setLocationData({
                        ...locationData,
                        houseNo: e.target.value,
                      })
                    }
                  />
                </Grid>

                <Grid size={{ xs: 12, md: 4, lg: 4 }}>
                  <CustomInput
                    label={"Street Address"}
                    value={locationData?.streetAddress}
                    placeholder={"Street Address"}
                    name={"streetAddress"}
                    onChange={(e) =>
                      setLocationData({
                        ...locationData,
                        streetAddress: e.target.value,
                      })
                    }
                  />
                </Grid>

                <Grid size={{ xs: 12, md: 4, lg: 4 }}>
                  <CustomInput
                    label={"City"}
                    placeholder={"City"}
                    name={"city"}
                    value={locationData?.city}
                    onChange={(e) =>
                      setLocationData({
                        ...locationData,
                        city: e.target.value,
                      })
                    }
                  />
                </Grid>

                <Grid size={{ xs: 12, md: 4, lg: 4 }}>
                  <CustomInput
                    label={"State"}
                    placeholder={"State"}
                    name={"state"}
                    value={locationData?.state}
                    onChange={(e) =>
                      setLocationData({
                        ...locationData,
                        state: e.target.value,
                      })
                    }
                  />
                </Grid>

                <Grid size={{ xs: 12, md: 4, lg: 4 }}>
                  <CustomInput
                    label={"Zip Code"}
                    placeholder={"Zip Code"}
                    name={"zipCode"}
                    value={locationData?.zipCode}
                    onChange={(e) =>
                      setLocationData({
                        ...locationData,
                        zipCode: e.target.value,
                      })
                    }
                  />
                </Grid>

                <Grid size={{ xs: 12, md: 4, lg: 4 }}>
                  <CustomInput
                    label={"Link to Consumer"}
                    placeholder={"Link to Consumer"}
                    name={"linkToCustomer"}
                    onChange={(e) => setLinkToCustomer(e.target.value)}
                    required={true}
                    value={linkToCustomer}
                  />
                </Grid>
              </Grid>
            </TabPanel>

            <TabPanel value={TABS[1]} sx={{ padding: 0 }}>
              <Grid container spacing={2}>
                <Grid size={{ xs: 12, md: 4, lg: 4 }}>
                  <CustomInput
                    label={"Latitude"}
                    placeholder={"Latitude"}
                    name={"latitude"}
                    value={locationData?.latitude}
                    onChange={(e) =>
                      setLocationData({
                        ...locationData,
                        latitude: e.target.value,
                      })
                    }
                  />
                </Grid>

                <Grid size={{ xs: 12, md: 4, lg: 4 }}>
                  <CustomInput
                    label={"Longitude"}
                    placeholder={"Longitude"}
                    name={"longitude"}
                    onChange={(e) =>
                      setLocationData({
                        ...locationData,
                        longitude: e.target.value,
                      })
                    }
                    value={locationData?.longitude}
                  />
                </Grid>
              </Grid>
            </TabPanel>

            <TabPanel value={TABS[2]} sx={{ padding: 0 }}>
              <Box display={"flex"} gap={"20px"}>
                <Stack width={"60%"}>
                  {siteIdInput.map((siteId, index) => (
                    <Stack
                      key={index}
                      direction={"row"}
                      gap={"20px"}
                      alignItems={"center"}
                      sx={{ marginBottom: "16px" }}
                    >
                      <Typography variant="body1" fontWeight={600}>
                        Site ID:
                      </Typography>

                      <CustomSearch
                        placeholder={"10 digits"}
                        sx={{
                          width: "400px",
                          height: "40px",
                        }}
                        value={siteId || ""}
                        name={`siteIdInput-${index}`}
                        onChange={(e) =>
                          handleSiteIdInputChange(e.target.value, index)
                        }
                        onClick={() => handleGoToSite(siteId)}
                      />

                      <Stack direction={"row"} gap={"10px"}>
                        <ContainedButton
                          label={"Go to Site"}
                          sx={{
                            width: "fit-content",
                            fontWeight: 600,
                            height: "35px",
                            color: "#ffffff",
                          }}
                          onClick={() => handleGoToSite(siteId)}
                        />
                        <Box
                          sx={{
                            backgroundColor: "#FA6B6B",
                            width: "35px",
                            height: "35px",
                            borderRadius: "4px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                          onClick={() => handleRemoveRow(index)}
                        >
                          <UnifiedIcon
                            icon={FaRegTrashAlt}
                            color="#ffffff"
                            style={{ marginBottom: "2px" }}
                          />
                        </Box>
                      </Stack>
                    </Stack>
                  ))}
                </Stack>
              </Box>

              <ContainedButton
                label={"Add Row"}
                sx={{
                  width: "fit-content",
                  fontWeight: 600,
                  color: "#ffffff",
                }}
                onClick={handleAddRow}
              />
            </TabPanel>

            {/* <Stack
              direction={"direction"}
              justifyContent={"space-between"}
              justifyItems={"center"}
              mt={"20px"}
            >

              <ContainedButton
                label={"Go to Commitment Contract"}
                
                sx={{
                  width: "fit-content",
                  fontWeight: 600,
                  height: "35px",
                  color: "#ffffff",
                }}
                onClick={() => navigate("/commitment")}
              />

              <ContainedButton
                label={"Add New Site"}
                
                sx={{
                  width: "fit-content",
                  fontWeight: 600,
                  height: "35px",
                  color: "#ffffff",
                }}
                onClick={() => navigate("/site")}
              />
            </Stack> */}
          </CardContent>
        </TabContext>
      </Card>
    </Layout>
  );
};

export default ConsumerLocation;
